import { useEffect } from 'react';
import { withTranslation } from 'react-i18next';

import AppLoaderV2 from './v2/AppLoader';

import { useMytaverseEvent } from '@core/dashboard/providers';

import { IAppLoader } from './interfaces';

const AppLoader = ({
  progressValue,
  showTeleportButton,
  handleTeleportButtonClick,
}: IAppLoader) => {
  const { setShowControls } = useMytaverseEvent();

  useEffect(() => {
    setShowControls(false);

    return () => {
      setShowControls(true);
    };
  }, []);

  // if (children) {
  //   return <AppLoaderV1>{children}</AppLoaderV1>;
  // }

  return (
    <AppLoaderV2
      progressValue={progressValue}
      showTeleportButton={showTeleportButton}
      handleTeleportButtonClick={handleTeleportButtonClick}
    />
  );
};

export default withTranslation()(AppLoader);
